import React from 'react'
import styled from 'styled-components'
import Form from './LongForm'

const Modal = styled.div`
  position: fixed;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  top: 0;
  .modal-content {
    background: #eee;
    position: absolute;
    top: 50%;
    left: 50%;
    max-width: 350px;
    transform: translate3d(-50%, -50%, 0);
    border-radius: 5px;
    box-shadow: 0px 50px 75px -25px rgba(0, 0, 0, 0.5);
  }
  @media screen and (max-width: 850px) {
    .modal-content {
      width: 100%;
    }
  }
`

let preventModalClosing = e => {
  e.stopPropagation()
}

let _Modal = props => (
  <div>
    {props.isOpen ? (
      <Modal onClick={props.closeModal}>
        <div className="modal-content" onClick={preventModalClosing}>
          <Form openedBy={props.openedBy} closeModal={props.closeModal} />
        </div>
      </Modal>
    ) : (
      ''
    )}
  </div>
)

export default _Modal



// WEBPACK FOOTER //
// ./src/components/Modal.js